<script>
import assetProvider from '@/pure/assetProvider';
import { roundPercentObjectValues } from '@/pure/round-percent-object-values';

export default {
  methods: {
    buildSiteBlock(site, collaborators, forcedTransport) {
      const { id, address, name, picture_path, index } = site;

      return {
        id,
        idx: index,
        type: 'site',
        name,
        address,
        transportDistribution: this.computeTransportDistribution(site, collaborators),
        forcedTransport: forcedTransport,
        poi: assetProvider[`poi${index + 1}`],
        image: picture_path || assetProvider.placeHolderSite,
      };
    },

    computeTrend(value, reverse) {
      if (reverse) {
        return {
          trend: value === 0 ? 0 : value < 0 ? 'up' : 'down',
          className: 'green',
          value: Math.abs(value),
          sub: ' min',
        };
      }

      return {
        trend: value === 0 ? 0 : value < 0 ? 'down' : 'up',
        className: value <= 0 ? 'green' : value > 10 && value <= 30 ? 'orange' : value > 30 ? 'red' : null,
        value: Math.abs(value),
        sub: ' min',
      };
    },

    computeAverageTime(sites, averageTime, collaborators, forcedTransport) {
      return sites.map(site => {
        let { details } = site;
        const difference = details.averageTimeDiff;
        return [
          this.buildSiteBlock(site, collaborators, forcedTransport),
          {
            value: details.averageTime,
            sub: ' min',
            className: null,
          },
          this.computeTrend(difference),
        ];
      });
    },

    computeImpact(sites, key, ignoreSite, collaborators, forcedTransport) {
      const { filteredCollaboratorsCount } = this.data;
      return sites.map(site => {
        const details = site.details.impact[key];
        const row = [];
        if (!ignoreSite) {
          row.push(this.buildSiteBlock(site, collaborators, forcedTransport));
        }
        row.push({
          entries: [
            {
              value: details.count,
              icon: 'people',
            },
            {
              value: filteredCollaboratorsCount ? Math.round((details.count / filteredCollaboratorsCount) * 100) : 0,
              sub: '%',
              className: null,
            },
          ],
        });
        row.push(this.computeTrend(details.averageTimeDiff, key === 'improvement'));
        return row;
      });
    },

    computeTimeTable(headerRanges, entries, subInfo) {
      const specifications = [];
      if (subInfo.subHeader) {
        specifications.push(subInfo.subHeader);
      }
      headerRanges.forEach((item, i) => {
        const current = {
          value: item,
          sub: subInfo.headerSub ? subInfo.headerSub : null,
          className: {
            big: true,
          },
        };
        if (subInfo.supHeaderCaption) {
          current.supCaption = subInfo.supHeaderCaption[i];
        }
        specifications.push(current);
      });
      return {
        specifications,
        entries,
      };
    },

    comuputesensibleCaseDecay(sites) {
      const { filteredCollaboratorsCount } = this.data;
      return sites.map(site => {
        const details = site.details.impact.sensibleCaseDecay;
        const row = [];
        const percent = filteredCollaboratorsCount ? Math.round((details.count / filteredCollaboratorsCount) * 100) : 0;
        row.push({
          entries: [
            {
              value: details.count,
              icon: 'people',
            },
            {
              value: percent,
              sub: '%',
            },
          ],
        });
        return row;
      });
    },

    computeTransportDistribution(site, collaborators) {
      if (collaborators && collaborators.length === 0) {
        return {
          custom: {
            public: 0,
            car: 0,
            bicycle: 0,
            walking: 0,
          },
          optimized: {
            public: 0,
            car: 0,
            bicycle: 0,
            walking: 0,
          },
        };
      }

      const siteCollaborators = collaborators.filter(collaborator => collaborator.sites.map(site => site.id).includes(site.id));

      const collaboratorsCustomTransport = siteCollaborators.map(
        collaborator =>
          collaborator.details.transportType
            .replaceAll(/\d/g, '') // replace 'public2025' or 'public2030' or 'public2027' or 'public2031' to 'public'
            .replaceAll('_without_toll', ''), // replace 'private_without_toll'                                       to 'private'
      );
      const collaboratorsCustomTransportCount = collaboratorsCustomTransport.length;

      const collaboratorsOptimizedTransport = siteCollaborators.map(collaborator =>
        collaborator.sites
          .find(s => s.id === site.id)
          // replace 'public2025' or 'public2030' or 'public2027' or 'public2031' to 'public'
          .optimizedSite.replaceAll(/\d/g, '')
          // replace 'private_without_toll'                                       to 'private'
          .replaceAll('_without_toll', ''),
      );
      const collaboratorsOptimizedTransportCount = collaboratorsCustomTransport.length;

      return {
        custom: roundPercentObjectValues({
          public: (collaboratorsCustomTransport.filter(c => c === 'public').length / collaboratorsCustomTransportCount) * 100,
          car: (collaboratorsCustomTransport.filter(c => c === 'private').length / collaboratorsCustomTransportCount) * 100,
          bicycle: (collaboratorsCustomTransport.filter(c => c === 'bicycle').length / collaboratorsCustomTransportCount) * 100,
          walking: (collaboratorsCustomTransport.filter(c => c === 'walking').length / collaboratorsCustomTransportCount) * 100,
        }),
        optimized: roundPercentObjectValues({
          public: (collaboratorsOptimizedTransport.filter(c => c === 'public').length / collaboratorsOptimizedTransportCount) * 100,
          car: (collaboratorsOptimizedTransport.filter(c => c === 'private').length / collaboratorsOptimizedTransportCount) * 100,
          bicycle: (collaboratorsOptimizedTransport.filter(c => c === 'bicycle').length / collaboratorsOptimizedTransportCount) * 100,
          walking: (collaboratorsOptimizedTransport.filter(c => c === 'walking').length / collaboratorsOptimizedTransportCount) * 100,
        }),
      };
    },

    checkRange(value, ranges) {
      for (var i = 0; i < ranges.length; i++) {
        if (value >= ranges[i].range[0] && value <= ranges[i].range[1]) {
          return ranges[i].color;
        }
      }
    },
  },
};
</script>
